module.exports = __webpack_public_path__ + "img/logo@2x.ef9357f9.png";